export default __webpack_public_path__ + "static/media/section2_2.3e821d6f.png";